import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProductPreview } from './components/ProductPreview';
import { HowItWorks } from './components/HowItWorks';
import { FeaturesGrid } from './components/FeaturesGrid';
import { SocialProof } from './components/SocialProof';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { ConnectAccountsPage } from './components/ConnectAccountsPage';
import { ViewStatementsPage } from './components/ViewStatementsPage';
import { ReconcilePage } from './components/ReconcilePage';
import { ReconciliationReportPage } from './components/ReconciliationReportPage';
import { MatchedResultPage } from './components/MatchedResultPage';
function LandingPage() {
  const navigate = useNavigate();
  const navigateToConnect = () => navigate('/connect');
  return <div className="min-h-screen bg-white font-sans text-gray-900 antialiased selection:bg-violet-100 selection:text-violet-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProductPreview data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <FeaturesGrid data-id="element-6" />
        <SocialProof data-id="element-7" />
        <PricingSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <CTASection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}
export function App() {
  return <Routes data-id="element-12">
      <Route path="/" element={<LandingPage data-id="element-14" />} data-id="element-13" />
      <Route path="/connect" element={<ConnectAccountsPage data-id="element-16" />} data-id="element-15" />
      <Route path="/statements" element={<ViewStatementsPage data-id="element-18" />} data-id="element-17" />
      <Route path="/reconcile" element={<ReconcilePage data-id="element-20" />} data-id="element-19" />
      <Route path="/matched-result" element={<MatchedResultPage data-id="element-22" />} data-id="element-21" />
      <Route path="/report" element={<ReconciliationReportPage data-id="element-24" />} data-id="element-23" />
    </Routes>;
}